import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpHeaders } from '@angular/common/http';
import { CommonApiService } from 'src/app/services/common-api.service';
import { environment } from 'src/environments/environment';
import { NgOtpInputConfig } from 'ng-otp-input';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css'],
})
export class LoginPageComponent implements OnInit {
  validateForm!: FormGroup;
  forgotPasswordForm!: FormGroup;
  confirmPasswordForm!: FormGroup;
  passwordVisible = false;
  loginConfirm = false;
  getMailModal = false;
  getOTPModal = false;
  OTPverified = false;

  // OPT INPUT CONFIG
  config: NgOtpInputConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '35px',
      height: '35px',
      fontSize: '22px',
    },
  };

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private postService: CommonApiService
  ) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url == '/') {
          this.router.navigate(['/login']);
        } else if (event.url == '/forgot-password') {
          this.getOTPModal = true;
        }
      }
    });
  }

  ngOnInit(): void {
    localStorage.removeItem('grlksftygesap');
    localStorage.removeItem('qweuserdataqwe');
    this.validateForm = this.fb.group({
      mailId: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required]],
    });

    this.forgotPasswordForm = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
    });

    this.confirmPasswordForm = this.fb.group({
      enteredPassword: ['', [Validators.required]],
      confirmedPassword: ['', [Validators.required]],
    });
    this.getToken();
  }

  submitForm() {
    let body = new URLSearchParams();
    let options = {
      headers: new HttpHeaders().set(
        'Content-Type',
        'application/x-www-form-urlencoded'
      ),
    };

    if (this.validateForm.valid) {
      body.set('email', this.validateForm.value.mailId);
      body.set('password', this.validateForm.value.password);
      this.loginConfirm = true;
      this.postService
        .commonPostMethod(body.toString(), environment.url + 'login', options)
        .subscribe((data) => {
          // console.log(data);
          var userData: any = data;
          if (userData.status == 'success') {
            environment.userData;
            localStorage.setItem('grlksftygesap', userData.data.sapCode);
            localStorage.setItem(
              'qweuserdataqwe',
              JSON.stringify(userData.data)
            );
            this.loginConfirm = false;
            this.router.navigate(['/dashboard']);
          } else if (userData.status == 'failed') {
            this.loginConfirm = false;
            this.toastr.error(userData.message, '', { timeOut: 2500 });
          }
        });
    } else {
      Object.values(this.validateForm.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  // GET INITIAL TOKEN

  getToken() {
    // API HEADER DATA STARTS
    let options = {
      headers: new HttpHeaders().set(
        'Content-Type',
        'application/x-www-form-urlencoded'
      ),
    };
    // API HEADER DATA ENDS
    // API BODY DATA STARTS
    let body = new URLSearchParams();
    body.set('username', 'sap');
    body.set('password', 'Sap@12345');
    body.set('grant_type', 'password');
    this.postService
      .commonPostMethod(body.toString(), environment.newUrl + 'token', options)
      .subscribe((response: any) => {
        // console.log(response);
        localStorage.setItem('lkjhgfdsa', response.access_token);
      });
  }

  // FORGOT PASSWORD SECTION

  validateEmail() {
    if (this.forgotPasswordForm.valid) {
      if (this.router.url == '/forgot-password') {
        this.closeModal();
        this.getOTPModal = true;
      } else {
        this.router.navigate(['/forgot-password']);
      }
    } else {
      Object.values(this.forgotPasswordForm.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  onOtpChange(event: any) {
    if (event.length == 6) {
      this.OTPverified = true;
    }
  }

  confirmPassword() {
    if (this.confirmPasswordForm.valid) {
      this.getOTPModal = false;
    } else {
      Object.values(this.confirmPasswordForm.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  // MODAL SECTION STARTS

  showModal() {
    this.toastr.success('Contact Administrator to Know the Credentials', '', { timeOut: 2500 });
    //this.getMailModal = true;
  }

  closeModal() {
    this.getMailModal = false;
  }
  closeOtpModal() {
    // this.getOTPModal = false;
    this.router.navigate(['/login']);
  }
}
